import React from "react";
import IFormContext from "../types/FormContext";

const FormContext = React.createContext<IFormContext | undefined>(undefined);

export default FormContext;
